var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      attrs: { model: _vm.form, rules: _vm.rules, "label-position": "top" }
    },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visible,
            "before-close": _vm.handleClose,
            title: "cPanel Addon Domains Tool",
            width: "94%"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Domain", prop: "domain" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.domain,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "domain", $$v)
                  },
                  expression: "form.domain"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Redirect Url", prop: "redirect_url" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.redirect_url,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "redirect_url", $$v)
                  },
                  expression: "form.redirect_url"
                }
              })
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("Cancel")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                [_vm._v("Save")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }